// extracted by mini-css-extract-plugin
export default {"root":"ExpiresInfo__root--1UJV_","root_colored":"ExpiresInfo__root_colored--16F1P","icon":"ExpiresInfo__icon--kiFeq"};